export default __webpack_public_path__ + "static/media/whiteTruckRightMobile.5b680e58.jpg";